import { Component, Inject, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { first, map, mergeMap, takeUntil, tap } from 'rxjs/operators';
import { combineLatest, from, Observable, of, Subject, zip } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import _reduce from 'lodash-es/reduce';
//import * as dayjs from 'dayjs';

//SERVICES
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfirmDialogService } from 'src/app/confirm-dialog/confirm-dialog.service';
import { CompassAPIListOptionsService } from 'src/app/shared/api-compass/compass-api-list-options.service';
import { CompassAPIProductsService } from 'src/app/shared/api-compass/compass-api-products.service';
import { CompassAPIReviewsService } from 'src/app/shared/api-compass/compass-api-reviews.service';
import { GlobalWatchService } from 'src/app/shared/services/global-watch.service';

//MODELS
import { ConfirmDialogOptions } from 'src/app/confirm-dialog/confirm-dialog-options.interface';
import { Product } from 'src/app/shared/models/product.interface';
import { ListOption } from 'src/app/shared/models/list-option.interface';
//import { ListButton } from 'ascedia-design-system/lib/models/list-button.interface';
import { Review } from 'src/app/shared/models/review.interface';
import { ResponseMessage } from 'src/app/shared/models/response-message.interface';
import { MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { AccountInfo, BrowserUtils, InteractionStatus, ServerError, RedirectRequest } from '@azure/msal-browser';
import { apiConfig, b2cPolicies } from 'src/app/auth/b2c-config';
import { StorageService } from 'src/app/shared/services/storage.service';


//COMPONENTS
import { TabGroupControllerComponent } from 'ascedia-design-system';
import { AuthHandlerService } from 'src/app/auth/auth-handler.service';


@Component({
	selector: 'app-excursions-edit-reviews-edit',
	templateUrl: './excursions-edit-reviews-edit.component.html'
})
export class ExcursionsEditReviewsEditComponent implements OnInit {

	public attemptedSubmit: boolean = false;
	public submitSuccessful: boolean = false;
	public responseMsg: ResponseMessage;

	public reviewId: string;

	public loading: boolean = true;
	public tabSetReroute: boolean = false;

	public idOrSlug: string;
	public regionSlug:string;
	public destinationSlug:string;

	public product$: Observable<Product>;
	public product: Product;

	public review: Review;
	public review$: Observable<Review>;

	public productForm: FormGroup;
	public reviewForm: FormGroup;

	public sectionActive: number = 0;
	public sectionActiveSub: number = 0;

	public reviewStatusArr: ListOption[];// = ['PENDING', 'APPROVED', 'SPAM', 'TRASH'];//TODO-JK: get rest of list.

	public tabList: any[];

	public statusColor: string;
	//public statusArr: string[] = ['PENDING', 'APPROVED', 'SPAM', 'TRASH'];//TODO-JK: get rest of list.

	public baseUrl: string = this._configService.urls.products.excursions;
	public baseUrlReviews: string = this._configService.urls.products.reviews;

	modalRef?: BsModalRef;

	@ViewChild('tabsMain') tabsMain: TabGroupControllerComponent;
	@ViewChild('tabsReviews') tabsReviews: TabGroupControllerComponent;
	@ViewChild('signInModalTemplate') signInModalTemplate:any;

	constructor(
		private _configService: ConfigService,
		private _confirmDialogService: ConfirmDialogService,
		private _compassAPIListOptionsService: CompassAPIListOptionsService,
		private _compassAPIProductsService: CompassAPIProductsService,
		private _compassAPIReviewsService: CompassAPIReviewsService,
		private formBuilder: FormBuilder,
		private _globalWatchService: GlobalWatchService,
		private route: ActivatedRoute,
		private router: Router,
		private _authHandlerService: AuthHandlerService,
		public modalService: BsModalService,
		private _msalBroadcastService: MsalBroadcastService,
		private authService: MsalService,
		private _storageService: StorageService,
	) { }

	ngOnInit(): void {
		this.idOrSlug = this.route.snapshot.paramMap.get('slug');
		this.regionSlug = this.route.snapshot.paramMap.get('regionSlug');
		this.destinationSlug = this.route.snapshot.paramMap.get('destinationSlug');
		//console.log('url:', this.regionSlug, this.destinationSlug, this.slug);

		this.reviewForm = new FormGroup({
			content: new FormControl(),
			createdOn: new FormControl(),
			headline:  new FormControl(),
			id: new FormControl(),
			modifiedOn:  new FormControl(),
			productId:  new FormControl(),
			rating:  new FormControl(),
			status:  new FormControl(),
			userId:  new FormControl(),
			verifiedPurchase:  new FormControl(),
			userDisplayName: new FormControl(),
			response: new FormGroup({
				content:  new FormControl(),
				userId:  new FormControl(),
				displayName:  new FormControl(),
				createdOn:  new FormControl(),
			})
		})


		this.route.data
			.subscribe((data: { product: Product }) => {
				this.processData(data.product);
			});

		let activeAcccount = this._authHandlerService.activeAccount();
		const blankGUID = '00000000-0000-0000-0000-000000000000'
		this.review = {
			status: 'PENDING',
			verifiedPurchase: false,
			productId: this.product.id,
			userId: activeAcccount ? activeAcccount.localAccountId : blankGUID,
			createdOn: new Date().toISOString(),
			modifiedOn: new Date().toISOString(),
			rating: 1, 
			id: '',
			userDisplayName: activeAcccount ? activeAcccount.name : '',
			response: {
				content: '',
				userId: activeAcccount ? activeAcccount.localAccountId : blankGUID,
				displayName: '',
				createdOn: new Date().toISOString()
			}
		}	
		// this.reviewForm.setValue({
		this.reviewForm.get("id").setValue(this.review.id);
		this.reviewForm.get("createdOn").setValue(this.review.createdOn);
		this.reviewForm.get("modifiedOn").setValue(this.review.modifiedOn);
		this.reviewForm.get("productId").setValue(this.review.productId); 
		this.reviewForm.get("rating").setValue(this.review.rating); 
		this.reviewForm.get("status").setValue(this.review.status); 		
		this.reviewForm.get("userId").setValue(this.review.userId);
		this.reviewForm.get("userDisplayName").setValue(this.review.userDisplayName);
		this.reviewForm.get("verifiedPurchase").setValue(this.review.verifiedPurchase);	
		this.reviewForm.get("response").get("userId").setValue(this.review.response.userId);
		this.reviewForm.get("response").get("createdOn").setValue(this.review.response.createdOn);
		this.reviewForm.get("response").get("content").setValue(this.review.response.content);
		this.reviewForm.get("response").get("displayName").setValue(this.review.response.displayName);
		
	}

	public resetForm() {
		//console.log('resetForm()');
		this.reviewForm.markAsPristine();
	}

	public getProductById(idOrSlug) {
		//console.log('getProductById.idOrSlug:', idOrSlug);
		this._compassAPIProductsService.getProductById(idOrSlug)
			.subscribe((res: Product) => {
				//console.log('getProductById.res', res);
				this.processData(res);

				
				this.loading = false;

			}, (err) => {
				console.error('getProductById.err', err);
			});
	}

	/**
	 * Process data
	 * @param data 
	 */
	public processData(data: Product) {
		//console.log('processData', data);
		this.product = data;
	}

	/**
	 * form on submit
	 */
	public onSubmit() {
		console.log('onSubmit()');
		this.attemptedSubmit = true;

		this.reviewForm.get('id').enable();//won't be included with other inputs if left disabled
		this.reviewForm.get('content').enable();
		this.reviewForm.get('productId').enable();
		this.reviewForm.get('userId').enable();
		this.reviewForm.get('rating').enable();
		this.reviewForm.get('headline').enable();
		this.reviewForm.get('response').get('createdOn').enable();
		this.reviewForm.get('response').get('userId').enable();

		const formValue = {
			...this.reviewForm.value,
			verifiedPurchase: JSON.parse(this.reviewForm.value.verifiedPurchase)
			// tags: this.reviewForm.value.tags
			// 	.map((checked, i) => checked ? this.tags[i] : null)
			// 	.filter(v => v !== null)
		}
		
		// console.log('reviewForm:', this.reviewForm.value);
		// console.log('formValue:', formValue);

		// console.log('POST review');
		const data = { ...formValue };
		delete data.id;

		this.review.headline = data.headline;
		this.review.content = data.content;

		if(data.headline && data.content){
			this.responseMsg = {status: 'Submitting...'};
			this._compassAPIReviewsService.postReviews(data)
				.pipe(first())
				.subscribe((res: Review) => {
					//console.log('postReviews.res', res);
					if (res.error) {
						this.responseMsg = {error: res.error};
						return this.reviewForm.value;
					} else {
						this.responseMsg = {success: 'Successfully added review.'};
						this.submitSuccessful = true;
						this.resetForm();
						return res;
					}

				});
			
			this.reviewForm.get('id').disable();
			this.reviewForm.get('content').disable();
			this.reviewForm.get('productId').disable();
			this.reviewForm.get('userId').disable();
			this.reviewForm.get('rating').disable();
			this.reviewForm.get('headline').disable();
			this.reviewForm.get('userDisplayName').disable();
			this.reviewForm.get('response').get('createdOn').disable();
			this.reviewForm.get('response').get('userId').disable();
		}
	}

	public flipRating(isThumbsUp: number){
		this.review.rating = isThumbsUp;
		this.reviewForm.get('rating').setValue(isThumbsUp);
	}
}
